import * as Actions from '../../actions/register/index';

const initialState = null;

const lead = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_LEAD:
        {
            return action.payload;
        }

        case Actions.REMOVE_LEAD:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default lead;